import Settings from '../constants/Settings';
import { pathToRegexp, compile } from "path-to-regexp";
import Cookies from 'universal-cookie';
const cookies = new Cookies();

const LanguageTools = {
    setLanguageCookie: (lng) => {
      cookies.set('language', lng, { path: process.env.REACT_APP_SUBFOLDER });
    },
    getLanguageCookie: () => {
      return cookies.get('language')?.toLowerCase();
    },
    // Site has the supplied language/locale
    // i.e. the given locale is supported by the site and has content in Contentful
    siteHasLocale: (locale) => {
        if (!locale || locale.length < 2){
            return false;
        }
        return Settings.languages.includes(locale.toLowerCase());
    },
    // Locale is in the EU
    localeIsEU: (locale) => {
        if (!locale || locale.length < 2){
            return false;
        }
        return Settings.languagesEU.includes(locale);
    },
    generateLanguage: (locale, location) => {
      const ROUTE = "/:locale/:path*";
      const definePath = compile(ROUTE);
      const routeComponents = pathToRegexp(ROUTE).exec(location.pathname);

      let subPaths = null;
      if (routeComponents && routeComponents[2]) {
        subPaths = routeComponents[2].split("/");
      }

      return definePath({
        locale,
        path: subPaths,
      });
    },
    localeFormatIncorrect: function(locale) {
        const localeParts = locale.split("-");
        if (localeParts.length < 2){
            return true;
        }
        const firstPart = localeParts[0].toLowerCase();
        const secondPart = localeParts[1].toLowerCase();
        if (firstPart.length !== 2 || secondPart.length !== 2){
            return true;
        }
        return false;
    },
    sniffLocale: function() {
      var browserLanguages = navigator.languages;
      if (browserLanguages){
        for (var i = 0; i < browserLanguages.length; i++) {
          var lang = browserLanguages[i].toLowerCase();

          // Exact matches
          if (Settings.languages.includes(lang)){
            return lang
          }

          // UK Matches
          if (Settings.languagesUK.includes(lang)){
            return "en-uk"
          }

          // Ireland Matches
          if (Settings.languagesIE.includes(lang)){
            return "en-ie"
          }

          // EU Matches
          if (Settings.languagesEU.includes(lang)){
            return "en-eu" // EU uses uk language
          }

          // French Matches
          if (Settings.languagesFR.includes(lang)){
            return "fr-fr"
          }

          // German MAtches
          if (Settings.languagesDE.includes(lang)){
            return "de-de"
          }

          // Dutch Matches
          if (Settings.languagesNL.includes(lang)){
            return "nl-nl"
          }

          // Italian Matches
          if (Settings.languagesIT.includes(lang)){
            return "it-it"
          }

          // Belgium French Matches
          if (Settings.languagesBEfr.includes(lang)){
            return "fr-be"
          }

          // Belgium Dutch Matches
          if (Settings.languagesBEnl.includes(lang)){
            return "nl-be"
          }

          // Portugal Matches
          if (Settings.languagesPT.includes(lang)){
            return "pt-pt"
          }

          // Spain Matches
          if (Settings.languagesES.includes(lang)){
            return "es-es"
          }
        }
      }
      return Settings.languageFallback;
    },
    getIsoCountryFromLocale: function(locale) {
      const localeParts = locale.split("-");
      const firstPart = localeParts[1] ? localeParts[1].toUpperCase() : "??";
      if  (firstPart == "UK") {
        return "GB";
      }
      return firstPart;
    },
    countryNameFromLocale: function(locale) {
      switch(locale){
        case 'en-eu':
          return "European Union";
        case 'en-uk':
          return "United Kingdom";
        case 'en-us':
          return "United States";
        case 'en-ie':
          return "Ireland";
        case 'de-de':
          return "Germany";
        case 'fr-fr':
          return "France";
        case 'it-it':
          return "Italy";
        case 'nl-nl':
          return "Netherlands";
        case 'de-at':
          return "Austria";
        case 'fr-be':
          return "Belgium (French)";
        case 'nl-be':
          return "Belgium (Dutch)";
        case 'pt-pt':
          return "Portugal";
        case 'es-es':
          return "Spain";
        default:
          return "United States";
      }
    },
    // Make sure locales sent to contentful are in correct format
    formatLocaleForContentful: function(locale) {
        const localParts = locale.split("-");
        const firstPart = localParts[0].toLowerCase();
        if (localParts.length < 2){
            console.warn("Locale format incorrect: " + locale);
            return firstPart;
        }
        let secondPart = localParts[1].toUpperCase();
        if (secondPart === "UK"){
            secondPart = "GB";
        }
        return firstPart + "-" + secondPart;
    }
};

export default LanguageTools;
